<template>
  <div>
    <div class="h-full w-full flex flex-col mt-0 md:mt-10">
      <div class="h-auto md:h-full w-full px-4 flex-auto">
        <div class="flex flex-col justify-center mb-4 md:mb-0">
          <h1 class="font-light text-slategrey text-lg xs:text-xl lg:text-2xl text-center md:text-left py-0 md:py-6">What’s on your mind?</h1>
        </div>
        <div class="flex flex-row md:flex-col justify-around md:justify-start mt-4 md:mt-0 flex-wrap md:flex-no-wrap">
          <div class="w-auto md:w-full flex justify-start items-center mb-4 md:mb-0">
            <div class="h-full flex-shrink-0 flex">
              <svg aria-hidden="true" class="w-6 h-6 text-rspurple my-1" width="20" height="20" fill="currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/></svg>
            </div>
            <div class="h-full flex-grow flex items-center pl-2">
              <a class="SofiaPro-Medium text-rspurple text-sm xs:text-base sm:text-xl lg:text-2xl" href="mailto:hello@yourdailyreset.com">hello@yourdailyreset.com</a>
            </div>
          </div>
          <div class="w-auto md:w-full flex justify-start items-center py-0 md:py-6 mb-4 md:mb-0">
            <div class="h-full flex-shrink-0 flex">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone h-6 w-6 text-rspurple" viewBox="0 0 16 16">
                <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
              </svg>
            </div>
            <div class="h-full flex-grow flex items-center pl-2">
              <a class="SofiaPro-Medium text-slategrey text-sm xs:text-base sm:text-xl lg:text-2xl">+97150 652 1063</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "",
    components: {},
    props: {
    },
    created() {
    },
    computed: {
    },
    data() {
        return {};
    },
}
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
</style>
